import { render, staticRenderFns } from "./PJCustomerContact.vue?vue&type=template&id=06d557b8"
import script from "./PJCustomerContact.vue?vue&type=script&lang=js"
export * from "./PJCustomerContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports